import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { useDataStore } from 'state/DataStore';

import EmbedFrame from 'components/EmbedFrame';
import Page from 'components/Page';

const WalkThrough = observer(() => {
    const dataStore = useDataStore();
    const { unitTypeSlug } = useParams();
    
    const unitType = dataStore.getItem('unit_types', 'slug', unitTypeSlug);

    // Check if walkthrough URL exists
    if (!unitType?.acf?.walkthrough_url) {
        return (
            <Page>
                <h3>No walkthrough content available for this unit type.</h3>
            </Page>
        );
    }

    return (
        <Page>
            <EmbedFrame
                src={unitType.acf.walkthrough_url}
                title="Unit Walkthrough"
            />
        </Page>
    );
});

export default WalkThrough;
